import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule} from '@angular/forms';
import { HttpModule} from '@angular/http';

import { AppComponent } from './app.component';
import { ServersComponent } from './welcome/servers.component';
import { ProjectsComponent } from './projects/projects.component';
import { ResumePageComponent } from './resume-page/resume-page.component';


@NgModule({
  declarations: [
    AppComponent,
    ServersComponent,
    ProjectsComponent,
    ResumePageComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/benge/Angular/my-first-app/src/app/app.module.ts